import { render, staticRenderFns } from "./AssetDetailForm.vue?vue&type=template&id=51630aa2&"
import script from "./AssetDetailForm.vue?vue&type=script&lang=ts&"
export * from "./AssetDetailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports